import React from "react";
import styled from "styled-components";
import { FaLinkedinIn, FaGithub } from "react-icons/fa";
import { Slide } from "react-awesome-reveal";
import profile from "../../assets/profilePhoto2.png";

const ProfComponent = () => {
  return (
    <Container id="home">
      <Slide direction="left">
        <Texts>
          <h4>
            Hello <span className="green">I'am</span>
          </h4>
          <h1 className="green">Saleem Malik</h1>
          <h3>Fullstack Developer</h3>
          <p>
            Innovative Full Stack Developer with 3+ years of experience in
            building and optimizing scalable digital solutions. Passionate about
            crafting seamless user experiences, enhancing system efficiency, and
            driving business growth through smart development strategies.
            Skilled in transforming complex requirements into high-performance
            applications across web and mobile platforms.
          </p>
          <button>
            <a target="blank" href="mailto:salimmalik.dev@gmail.com">
              Let's talk
            </a>
          </button>
          <button>
            <a href="https://drive.usercontent.google.com/download?id=1BLEcff1qqsZmVrC2M9cat8-xkp7IMXZd&export=download&authuser=0&confirm=t&uuid=2e9748aa-9626-42c9-816a-0f25703fead8&at=APZUnTUPbeZ-7uN3mvWDWa3pdRCN:1695835605897">
              Resume
            </a>
          </button>
          <Social>
            <p>Check out my</p>
            <div className="social-icons">
              {/* <span>
                <a href="/">
                  <AiOutlineInstagram />
                </a>
              </span> */}
              <span>
                <a
                  target="blank"
                  href="https://www.linkedin.com/in/saleem-malik-147775229/"
                >
                  <FaLinkedinIn />
                </a>
              </span>
              <span>
                <a target="blank" href="https://github.com/SalimMalik-123/">
                  <FaGithub />
                </a>
              </span>
            </div>
          </Social>
        </Texts>
      </Slide>
      <Slide direction="right">
        <Profile>
          <img
            className=""
            loading="lazy"
            style={{ borderRadius: "50%" }}
            src={profile}
            //src={"https://res.cloudinary.com/ghazni/image/upload/v1659082282/Yt-portfolio/Untitled-1_drcspz.png"}
            alt="profile Image"
          />
        </Profile>
      </Slide>
    </Container>
  );
};

export default ProfComponent;

const Container = styled.div`
  display: flex;
  gap: 2rem;
  padding-top: 3rem;
  width: 80%;
  max-width: 1280px;
  margin: 0 auto;
  z-index: 1;
  @media (max-width: 840px) {
    width: 90%;
  }

  @media (max-width: 640px) {
    flex-direction: column;
  }
`;
const Texts = styled.div`
  flex: 1;
  h4 {
    padding: 1rem 0;
    font-weight: 500;
  }
  h1 {
    font-size: 2rem;
    font-family: "Secular One", sans-serif;
    letter-spacing: 2px;
  }
  h3 {
    font-weight: 500;
    font-size: 1.2rem;
    padding-bottom: 1.2rem;
    text-transform: capitalize;
  }
  p {
    font-weight: 300;
  }

  button {
    padding: 0.7rem 2rem;
    margin-top: 3rem;
    margin-right: 20px;
    cursor: pointer;
    background-color: #01be96;
    border: none;
    color: #fff;
    font-weight: 500;
    filter: drop-shadow(0px 10px 10px #01be9551);
    :hover {
      filter: drop-shadow(0px 10px 10px #01be9570);
    }
    a {
      font-weight: 500;
      color: #ffffff;
    }
  }
`;
const Social = styled.div`
  margin-top: 3rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  p {
    font-size: 0.9rem;
    @media (max-width: 690px) {
      font-size: 0.7rem;
    }
  }

  .social-icons {
    display: flex;
    align-items: center;
    gap: 1rem;
    span {
      width: 2.3rem;
      height: 2rem;
      clip-path: polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%);
      background-color: #01be96;
      position: relative;
      transition: transform 400ms ease-in-out;
      :hover {
        transform: rotate(360deg);
      }
    }

    a {
      color: #fff;
      position: absolute;
      top: 55%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;
const Profile = styled.div`
  img {
    width: 310px;
    height: 310px;
    filter: drop-shadow(0px 10px 10px #01be9570);
    transition: transform 400ms ease-in-out;
    @media (max-width: 790px) {
      width: 20rem;
    }

    @media (max-width: 660px) {
      width: 210px;
      height: 220px;
    }

    @media (max-width: 640px) {
      width: 220px;
      height: 220px;
    }
  }

  :hover img {
    transform: translateY(-10px);
  }
`;
